import { render, Component } from 'preact'
import $ from 'jquery'
import map from 'lodash/map'
import Widget from './base.js'
import profilePromise from 'tpm-lib/profile'
import { env } from 'tpm-utils'

const BookmarksLoader = {
  endpoint(path) {
    if (path && path[0] !== '/') path = '/' + path

    return `${location.protocol}//${location.hostname}${path || ''}`
  },

  load() {
    return (this._ajax =
      this._ajax ||
      profilePromise().then(profile => {
        if (env.isProduction() && profile.isPrime()) {
          return $.ajax({
            url: this.endpoint('/bookmarks.json'),
            data: { source: self.pivot_id },
            method: 'GET',
            xhrFields: {
              withCredentials: true,
            },
          })
        } else {
          return { bookmarks: [], source_is_bookmarked: false }
        }
      }))
  },
}

class BookmarkItem extends Component {
  render({ bookmark }) {
    return (
      <div className="Bookmarks__Item --span-3">
        <div className="row">
          <img
            className="--span-2"
            src={`https://res.cloudinary.com/tpm/image/upload/c_thumb,g_faces,w_42,h_42,f_auto,q_auto,fl_lossy,dpr_2.0/${
              bookmark.cloudinary_id
            }.jpg`}
          />
          <div className="--span-4">
            <a href={bookmark.story_url}>{bookmark.title}</a>
            <p>{bookmark.pubdate}</p>
          </div>
        </div>
      </div>
    )
  }
}

export class BookmarksPanel extends Widget {
  constructor() {
    super()

    this.state.open = false
  }

  componentWillMount() {
    $('.Header__BookmarksBtn').click(e => {
      this.toggle()
    })

    BookmarksLoader.load().then(json => {
      const content = json.bookmarks
      this.setState({ content })
    })
  }

  toggle() {
    this.setState({ open: !this.state.open })
  }

  renderContent() {
    const items = map(this.state.content, bm => {
      return <BookmarkItem bookmark={bm} />
    })

    return (
      <div class="row">
        <div className="--span-6">
          <div className="row">
            <div className="Bookmarks__Header --span-6">BOOKMARKS</div>
          </div>
          <div className="row">{items}</div>
          <div className="row">
            <div class="Bookmarks__ManageButton --span-2 --push-4">
              <div class="row">
                <a href="/accounts/bookmarks">
                  <button class="btn btn-primary --span-6">
                    Manage All Bookmarks
                  </button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  renderLoader() {
    return <em>loading</em>
  }

  render() {
    const props = {
      style: { display: this.state.open ? 'block' : 'none' },
      className: 'Bookmarks --span-6',
    }

    let children
    if (this.state.content) children = this.renderContent()
    else children = this.renderLoader()

    return <div {...props}>{children}</div>
  }
}

export class BookmarksControl extends Widget {
  componentWillMount() {
    this.state = {
      bookmarked: false,
      loaded: false,
      requesting: false,
    }

    BookmarksLoader.load().then(json => {
      this.setState({
        bookmarked: json.source_is_bookmarked,
        loaded: true,
      })
    })
  }

  handleClick() {
    if (!this.state.requesting) {
      this.setState({ requesting: true })
      $.ajax({
        url: BookmarksLoader.endpoint(`/bookmark/Article/${self.pivot_id}`),
        method: this.state.bookmarked ? 'DELETE' : 'POST',
        xhrFields: { withCredentials: true },
      }).then(() => {
        this.setState({
          bookmarked: !this.state.bookmarked,
          requesting: false,
        })
      })
    }
  }

  render() {
    if (this.state.loaded) {
      const status = () => {
        if (this.state.requesting) return ''
        else if (this.state.bookmarked) return ''
      }
      return (
        <div className="Bookmark">
          <a onClick={this.handleClick.bind(this)}>
            <i
              className={`fa${this.state.bookmarked ? 's' : 'r'} fa-bookmark`}
            />
          </a>
        </div>
      )
    }
  }
}
